/*
 * Page Name
 */

(function ($) {

    _heightline({
        itemClsName: '.beginner_block04_item .img',
        itemPerRow: 3,
        device: 'pc'
    });

    _heightline({
        itemClsName: '.beginner_block03_item .img',
        itemPerRow: 4,
        device: 'pc'
    });

})(jQuery);